import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { SelectProgramme, SelectClassGroup } from "../Include/DynamicSelect";
import ListSchoolFee from "./ListSchoolFee";
import { ADD_FEE_ACCOUNTING } from "../../Schema/SchoolFees";

export default function CreateSchoolFee({ open, handleClose, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [requireField, setRequireField] = useState(false);

  const newFeeData = {
    discountPercentage: "",
    discountPrice: "",
    duration: "",
    price: "",
    key: Date.now() + Math.random(),
  };

  const [programmVal, setProgrammVal] = useState({ id: "", title: "" });
  const [classGroupVal, setClassGroupVal] = useState({ id: "", title: "" });
  const [feeListData, setFeeListData] = useState([newFeeData]);

  const [addFeeAccouting] = useMutation(ADD_FEE_ACCOUNTING, {
    onCompleted: ({ addFeeAccouting }) => {
      setLoading(false);
      if (addFeeAccouting?.status === true) {
        setAlert(true, "success", addFeeAccouting?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", addFeeAccouting?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    classGroup: Yup.string(),
    gradeName: Yup.string().required("required!"),
    programme: Yup.string(),
    adminFee: Yup.string(),
    type: Yup.string().required("required!"),
  });

  const formik = useFormik({
    initialValues: {
      classGroup: "",
      programme: "",
      gradeName: "",
      adminFee: "",
      type: "AdminFee",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      let createStatus = false;
      const BreakException = {};
      try {
        if (feeListData?.length === 0) setFeeListData([newFeeData]);
        if (feeListData?.length !== 0) {
          feeListData?.forEach(function (elem) {
            if (
              elem?.price !== "" &&
              elem?.price !== undefined &&
              elem?.duration !== undefined &&
              elem?.duration !== ""
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (createStatus) {
        const newFeeListData = feeListData?.map((item) => ({
          discountPercentage: parseFloat(item?.discountPercentage),
          discountPrice: parseFloat(item?.discountPrice),
          price: parseFloat(item?.price),
          duration: item?.duration,
        }));

        addFeeAccouting({
          variables: {
            input: {
              ...values,
              fees: newFeeListData,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;

  useEffect(() => {
    if (programmVal?.id) {
      setFieldValue("programme", programmVal?.id);
    } else {
      setFieldValue("programme", "");
    }
  }, [programmVal?.id]);

  useEffect(() => {
    if (classGroupVal?.id) {
      setFieldValue("classGroup", classGroupVal?.id);
    } else {
      setFieldValue("classGroup", "");
    }
  }, [classGroupVal?.id]);

  useEffect(() => {
    setProgrammVal({ id: "", title: "" });
    setClassGroupVal({ id: "", title: "" });
    setFeeListData([newFeeData]);
    resetForm();
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Create Fee</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Fee Type</Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={values?.type}
                    onChange={(e) => setFieldValue("type", e.target.value)}
                  >
                    <MenuItem value={"AdminFee"}>Admin Fee</MenuItem>
                    <MenuItem value={"Material"}>Material</MenuItem>
                    <MenuItem value={"Tuition"}>Tuition</MenuItem>
                    <MenuItem value={"Uniform"}>Uniform</MenuItem>
                    <MenuItem value={"Transportation"}>Transportation</MenuItem>
                    <MenuItem value={"Meal"}>Meal</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">Fee Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="fee name"
                  {...getFieldProps("gradeName")}
                  error={Boolean(touched.gradeName && errors.gradeName)}
                  helperText={touched.gradeName && errors.gradeName}
                />
              </Grid>

              {values?.type === "Tuition" ? (
                <>
                  <Grid item xs={12} md={6}>
                    <Typography className="field-title">Programme</Typography>
                    <SelectProgramme
                      selectedVal={programmVal}
                      setSelectedVal={setProgrammVal}
                    />
                    {values?.type === "Tuition" && programmVal?.id === "" && (
                      <FormHelperText error id="outlined-adornment-password">
                        require!
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography className="field-title">Class Group</Typography>
                    <SelectClassGroup
                      programmeId={programmVal?.id}
                      selectedVal={classGroupVal}
                      setSelectedVal={setClassGroupVal}
                    />
                    {values?.type === "Tuition" && classGroupVal?.id === "" && (
                      <FormHelperText error id="outlined-adornment-password">
                        require!
                      </FormHelperText>
                    )}
                  </Grid>
                </>
              ) : null}

              <Grid item xs={12} md={12}>
                <ListSchoolFee
                  requireField={requireField}
                  feeListData={feeListData}
                  setFeeListData={setFeeListData}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    disabled={
                      (values?.type === "Tuition" &&
                        classGroupVal?.id === "") ||
                      (values?.type === "Tuition" && classGroupVal?.id === "")
                    }
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
